import React from "react";
import "./profileHeader.style.scss";

const ProfileHeader = ({ imageURL, displayName, toggleDisplay, subtitle, about, myPage, onCreate, displayThisButton }) => {

    return (
        <div
            className="profile-header"
            style={{ marginTop: '40px', marginBottom: '12px' }}
        >
            <div className="inf-image-wrapper">
                <div
                    className="inf-image"
                    style={{
                        backgroundImage: `url(${imageURL})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                </div>
            </div>
            <div className="inf-info">
                <div className="inf-title">
                    <h1>{displayName}</h1>
                </div>
                <div className="inf-bio">
                    <div className='top clamped'>
                        {
                            about.split('\n\n').map((paragraph, index) => (
                                <React.Fragment key={index}>
                                    <p onClick={toggleDisplay} style={{ marginBottom: '12px', textAlign: 'left' }}>{paragraph}</p>
                                </React.Fragment>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileHeader;